import React from 'react';
import logoSvg from '../logonew.svg';

interface LogoProps {
  className?: string;
  size?: number;
}

const Logo: React.FC<LogoProps> = ({ className = '', size = 40 }) => {
  return (
    <div 
      className={className}
      style={{ 
        width: size, 
        height: size,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      <img 
        src={logoSvg} 
        alt="Womanalytics Logo" 
        style={{ 
          width: '100%', 
          height: '100%',
          objectFit: 'contain'
        }} 
      />
    </div>
  );
};

export default Logo;

